import { money, when, STATUS_LABELS, STATUS_TONE } from "../../lib/adminApi";

export const StatusBadge = ({ status, testId }) => (
  <span className={`inline-block px-2 py-0.5 border text-[11px] font-mono uppercase tracking-wide ${STATUS_TONE[status] || "text-gray-300 border-white/20"}`} data-testid={testId}>
    {STATUS_LABELS[status] || status}
  </span>
);

export const OrdersTable = ({ orders, onOpen, selectedId }) => {
  if (orders.length === 0) return <p className="text-gray-500 py-12 text-center border border-white/10 bg-[#141414]" data-testid="orders-empty">No orders match.</p>;
  return (
    <div className="overflow-x-auto border border-white/10 bg-[#141414]">
      <table className="w-full text-sm" data-testid="orders-table">
        <thead>
          <tr className="text-left font-mono text-[11px] uppercase tracking-[0.15em] text-gray-500 border-b border-white/10">
            <th className="px-4 py-3">Order</th><th className="px-4 py-3">Date</th><th className="px-4 py-3">Customer</th>
            <th className="px-4 py-3 hidden md:table-cell">Company</th><th className="px-4 py-3 text-right">Total</th>
            <th className="px-4 py-3">Payment</th><th className="px-4 py-3">Fulfillment</th><th className="px-4 py-3 hidden lg:table-cell">Tracking</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={o.order_id} onClick={() => onOpen(o)} className={`border-b border-white/5 cursor-pointer hover:bg-white/5 transition-colors ${selectedId === o.order_id ? "bg-white/5" : ""}`} data-testid={`order-row-${o.order_number}`}>
              <td className="px-4 py-3 font-mono text-white font-bold whitespace-nowrap">{o.order_number}</td>
              <td className="px-4 py-3 text-gray-400 whitespace-nowrap">{when(o.created_at)}</td>
              <td className="px-4 py-3 text-gray-200">{o.customer.first_name} {o.customer.last_name}<div className="text-gray-500 text-xs">{o.customer.email}</div></td>
              <td className="px-4 py-3 text-gray-300 hidden md:table-cell">{o.customer.company || "—"}</td>
              <td className="px-4 py-3 text-right text-white font-bold whitespace-nowrap">{money(o.total_cents ?? o.subtotal_cents)}</td>
              <td className="px-4 py-3"><span className="font-mono text-xs uppercase text-gray-300" data-testid={`order-row-${o.order_number}-payment`}>{o.payment_status}</span></td>
              <td className="px-4 py-3"><StatusBadge status={o.status} testId={`order-row-${o.order_number}-status`} /></td>
              <td className="px-4 py-3 text-gray-400 font-mono text-xs hidden lg:table-cell">{o.tracking_number || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
